/**
 * ProposalListContainer
 * --
 */
import React from 'react';
import ProposalListPresenter from './ProposalListPresenter';

const ProposalListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ProposalListPresenter />
    </>
  );
};

export default ProposalListContainer;
